<template>
  <mm-tab-title v-model="tab" :titles="titles">
      <el-button slot="save" size="medium" type="primary" @click="submit">save</el-button>
      <el-form ref="form" :model="result" size="small" label-width="120px">
      
          <div v-show="tab===1">
            <el-form-item label="Offer Month" required>
              <el-date-picker
                v-model="result.offer_month"
                type="month"
                value-format="yyyy-MM"
                :readonly="edit"
                placeholder="Select" style="width:100%;" />
            </el-form-item>
              <el-form-item v-if="edit" label="Offer Id" prop="offer_id" >
                  <el-input v-model.number="result.offer_id"   readonly />
              </el-form-item>
              <el-form-item label="Offer Name" prop="offer_name"  required>
                  <el-input v-model="result.offer_name" />
              </el-form-item>
              <el-form-item label="Adv Offer Id" required prop="adv_offer_id">
                  <el-input v-model.trim="result.adv_offer_id" />
              </el-form-item>
              <el-form-item label="Af Prt" prop="af_prt">
                  <el-input v-model.trim="result.af_prt" />
              </el-form-item>
              <el-form-item label="Offer Type" prop="offer_type" required>
                  <el-radio-group v-model="result.offer_type">
                    <el-radio label='old'>Old</el-radio>
                    <el-radio label='new'>New</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="Advertiser" required prop="adv_id">
                  <mm-adv-select no_paused v-model="result.adv_id" />
              </el-form-item>
              <el-form-item label="Tracker" prop="tracker_id">
                  <!-- <mm-adv-select no_paused isTracker v-model="result.tracker_id" /> -->
                  <mm-dict-select v-model="result.tracker_id" dictType="tracker"></mm-dict-select>
              </el-form-item>
              <el-form-item label="Manager" required prop="offer_bd">
                  <mm-users v-model="result.offer_bd"/>
              </el-form-item>
              <el-form-item label="Offer Price" prop="offer_price" required >
                  <el-input type="number" @mousewheel.native.prevent v-model="result.offer_price"/>
              </el-form-item>
              <el-form-item label="Cap" prop="cap_info" >
                  <!-- <el-input type="number" @mousewheel.native.prevent v-model="result.cap_info" /> -->
                  <el-input @mousewheel.native.prevent v-model.trim="result.cap_info" />
              </el-form-item>
              <el-form-item label="Pricing Model" prop="pricing_model" required>
                  <mm-radio v-model="result.pricing_model" :options="priceModelOptions"/>
              </el-form-item>
              <el-form-item label="Traffic Type" prop="traffic_type" required>
                  <mm-radio v-model="result.traffic_type" :options="trafficTypeOptions"/>
              </el-form-item>
              <el-form-item label="Platform" prop="platform" required>
                  <mm-radio v-model="result.platform" :options="platformOptions"/>
              </el-form-item>
              <el-form-item label="Manual Status" prop="manual_status" required>
                  <mm-radio v-model="result.manual_status" :options="manualStatusOptions"/>
              </el-form-item>
              <el-form-item label="Category" prop="category">
                  <mm-offer-category :type="result.platform" v-model="result.category"/>
              </el-form-item>
              <el-form-item label="Geo" prop="geo" required>
                  <el-input v-model.trim="result.geo" type="textarea" :rows="2" />
              </el-form-item>
              <el-form-item label="Offer Kpi" prop="kpi"  >
                  <el-input v-model="result.kpi" type="textarea" :rows="5" />
              </el-form-item>
              <el-form-item label="Events" prop="events">
                <el-button size="medium" type="success" @click="addEvent">ADD</el-button>
                <div v-for="(item, key) in result.events" :key="key" style="padding-left: 30px;">
                  <div style="padding-bottom:10px;">
                    <span style="padding-right:20px;">Event {{ key+1 }}</span>
                    <el-button size="medium" type="danger" @click="deleteEvent(key)">Delete Event {{ key+1 }}</el-button>
                  </div>
                  <el-form-item label="Event Name" label-width="100px">
                    <el-input v-model.trim="item.event_name" style="width:300px;"></el-input>
                  </el-form-item>
                  <el-form-item label="Event Value" required label-width="100px">
                    <el-input v-model.trim="item.event_value" style="width:300px;"></el-input>
                  </el-form-item>
                  <el-form-item label="Payout" label-width="100px">
                    <el-input type="number" @mousewheel.native.prevent v-model="item.payout" style="width:300px;"/>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="Remark" prop="remark"  >
                  <el-input v-model="result.remark" type="textarea" :rows="5" />
              </el-form-item>
          </div>
          
          <div v-show="tab===2">
              <el-form-item label="App Name" prop="app_name">
                  <el-input v-model="result.app_name" />
              </el-form-item>
              <el-form-item label="Package Id" prop="package_id">
                  <el-input v-if="result.platform != 'both'" v-model.trim="result.package_id" />
                  <div v-else>
                    <div style="display:flex;"><span style="width:50px;">AOS:</span><el-input v-model="package_ids[0]"></el-input></div>
                    <div style="display:flex;"><span style="width:50px;">IOS:</span><el-input v-model="package_ids[1]"></el-input></div>
                  </div>
              </el-form-item>
              <el-form-item label="Preview Url" prop="preview_url">
                  <el-input v-if="result.platform != 'both'" v-model.trim="result.preview_url" />
                  <div v-else>
                    <div style="display:flex;"><span style="width:50px;">AOS:</span><el-input v-model="preview_urls[0]"></el-input></div>
                    <div style="display:flex;"><span style="width:50px;">IOS:</span><el-input v-model="preview_urls[1]"></el-input></div>
                  </div>
              </el-form-item>
              <el-form-item label="Icon Url" prop="icon_addr">
                  <el-input v-model.trim="result.icon_addr" />
              </el-form-item>
              <el-form-item label="App Description" prop="description"  >
                  <el-input v-model="result.description" type="textarea" :rows="5" />
              </el-form-item>
              <el-form-item label="Creatives" prop="creatives"  >
                  <el-input v-model="result.creatives" type="textarea" :rows="5" />
              </el-form-item>
          </div>
      </el-form>

  </mm-tab-title>


</template>

<script>
function mapUppercase(v){
return {label:v.toUpperCase(),value:v}
}
function mapUppercase1(v){
let label = v;
label = label.slice(0,1).toUpperCase()+label.slice(1);
return {label:label,value:v}
}
const priceModelOptions = ['cpi','cpa','cpc','cpe','cps'].map(mapUppercase);
const manualStatusOptions = ['active','pending','paused'].map(mapUppercase1);
const trafficTypeOptions = ['non-incent','incent','uncertain'].map(mapUppercase1);
const platformOptions = [
  {label:'Android',value:'android'},
  {label:'IOS',value:'ios'},
  {label:'others',value:'Others'},
  {label:'both OS',value:'both'}
];
export default {
props: ["edit"],
watch:{
  '$route' (to, from) {
    this.loadData();
  },
},
data() {
  const date_format = this.$utils.date_format;
  return {
    result: {
      offer_month: date_format(new Date(), 'YYYY-MM'),
      manual_status: 'active',
      pricing_model:'cpi',
      platform:'android',
      traffic_type:'non-incent',
      offer_type: 'new',
      offer_id:'',
      events: [],
    },
    package_ids: ['', ''],
    preview_urls: ['', ''],
    manualStatusOptions,
    priceModelOptions,
    platformOptions,
    trafficTypeOptions,
    tab: 1,
    titles:['Base Info','App Info'],
  };
},
methods: {
  async submit() {
    await this.$validate(this.$refs.form);
    if (this.result.events && this.result.events.length) {
      let flag = false;
      for (const event of this.result.events) {
        if (!event.event_value) {
          flag = true;
        }
      }
      if (flag) {
				this.$message({
					type:'error',
					message:'Event Value can not be empty',
				});
				return;
      }
    }
    if (this.result.platform == 'both') {
      this.result.package_id = this.package_ids.join(',\n');
      this.result.preview_url = this.preview_urls.join(',\n');
    }
    const request_path = this.edit?'/mmpOffer/update':'/mmpOffer/create';
    const result = await this.$post(request_path,this.result);
    if(this.edit){
      this.loadData();
    }else{
      this.$router.push({ path: "/mmpOfferEdit",query:{id:result.offer_id,month:this.result.offer_month} });
    }
          
  },
  async loadData() {
    const month = this.$route.query['month'];
    if (this.edit) {
      const id = this.$route.query['id'];
      const result = await this.$post('/mmpOffer/detail',{offer_id:id, offer_month: month});
      if (!result.events || result.events.length == 0) {
        result.events = [];
      }
      this.result = result;
    } else if (this.$route.query['copy_id']) {
      this.result = await this.$post('/mmpOffer/detail',{offer_id:this.$route.query['copy_id'], offer_month: month});
      delete this.result.offer_id;
      delete this.result.adv_offer_id;
      delete this.result._id;
      delete this.result.__v;
      delete this.result.create_at;
      delete this.result.update_at;
      this.result.offer_name = 'COPY_' + this.result.offer_name;
    }
    if (this.result.platform == 'both') {
      if (this.result.preview_url) {
        const arr = this.result.preview_url.split(',\n');
        this.preview_urls[0] = arr[0] || '';
        this.preview_urls[1] = arr[1] || '';
      }
      if (this.result.package_id) {
        const arr = this.result.package_id.split(',\n');
        this.package_ids[0] = arr[0] || '';
        this.package_ids[1] = arr[1] || '';
      }
    }
  },
  addEvent() {
    this.result.events.push({
      event_name: '',
      event_value: '',
      payout: 0,
    })
  },
  deleteEvent(index) {
    this.result.events.splice(index, 1);
  },
},
  
beforeMount() {
  this.loadData();
}
};
</script>